module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.marked(_vm.readme))
    }
  }), _vm._v(" "), _c('vc-style', [_vm._v("\n  body\n  {\n    font-family: " + _vm._s(_vm.fontFamily) + ";\n    color: " + _vm._s(_vm.color) + ";\n  }\n\n  blockquote\n  {\n    padding: 0;\n    margin: 0;\n  }\n  ")]), _vm._v(" "), _c('vc-social-bar', {
    attrs: {
      "title": _vm.description,
      "position": "right",
      "services": _vm.services
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ce7d586","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app.vue
// module id = 17
// module chunks = 0